export default __webpack_public_path__ + "static/media/uploader-animas-problem-2.b898540e.png";